// extracted by mini-css-extract-plugin
module.exports = {"lia-last-modified":"FeaturedWidgetLastModifiedInfo_lia-last-modified__vQ3PG","lia-user":"FeaturedWidgetLastModifiedInfo_lia-user__jYxZk"};